<div class="flex h-full flex-col">
  <div
    class="companies-loader-container flex h-1 grow flex-col gap-8 overflow-y-auto">
    <router-outlet class="hidden"></router-outlet>
  </div>
</div>

<div class="hidden">
  <p-select></p-select>
  <p-button></p-button>
  <p-table [paginator]="true"></p-table>
  <input pInputText />
  <p-popover></p-popover>
  <p-chip></p-chip>
  <p-toast></p-toast>
  <p-checkbox></p-checkbox>
  <p-progress-spinner></p-progress-spinner>
  <form [formGroup]="form">
    <p-radiobutton formControlName="radiobutton"></p-radiobutton>
    <p-datepicker formControlName="datepicker"></p-datepicker>
  </form>
  <p-selectbutton
    [options]="routes"
    [ngModel]="value()"
    optionLabel="label"
    optionValue="value" />
  <p-tag severity="info" value="Info" [rounded]="true"></p-tag>
  <p-toggleswitch />
  <textarea rows="5" cols="30" pTextarea></textarea>
  <p-multiselect></p-multiselect>
  <p-tabs></p-tabs>
  <p-inputnumber></p-inputnumber>
  <p-floatlabel variant="in" class="grow"></p-floatlabel>
  <p-stepper [(value)]="activeStep" class="basis-[40rem]">
    <p-step-list>
      <p-step [value]="1" class="flex flex-auto flex-row gap-2">
        <ng-template
          #content
          let-activateCallback="activateCallback"
          let-value="value">
          <button
            class="inline-flex flex-col gap-2 border-0 bg-transparent"
            (click)="activateCallback()">
            <span
              class="inline-flex h-12 w-12 items-center justify-center rounded-full border-2"
              [ngClass]="{
                'border-primary bg-primary text-primary-contrast':
                  value <= activeStep,
                'border-surface': value > activeStep,
              }">
              <i class="pi pi-user"></i>
            </span>
          </button>
        </ng-template>
      </p-step>

      <p-step [value]="2" class="flex flex-auto flex-row gap-2">
        <ng-template
          #content
          let-activateCallback="activateCallback"
          let-value="value">
          <button
            class="inline-flex flex-col gap-2 border-0 bg-transparent"
            (click)="activateCallback()">
            <span
              class="inline-flex h-12 w-12 items-center justify-center rounded-full border-2"
              [ngClass]="{
                'border-primary bg-primary text-primary-contrast':
                  value <= activeStep,
                'border-surface': value > activeStep,
              }">
              <i class="pi pi-star"></i>
            </span>
          </button>
        </ng-template>
      </p-step>

      <p-step [value]="3" class="flex flex-auto flex-row gap-2">
        <ng-template
          #content
          let-activateCallback="activateCallback"
          let-value="value">
          <button
            class="inline-flex flex-col gap-2 border-0 bg-transparent"
            (click)="activateCallback()">
            <span
              class="inline-flex h-12 w-12 items-center justify-center rounded-full border-2"
              [ngClass]="{
                'border-primary bg-primary text-primary-contrast':
                  value <= activeStep,
                'border-surface': value > activeStep,
              }">
              <i class="pi pi-id-card"></i>
            </span>
          </button>
        </ng-template>
      </p-step>
    </p-step-list>

    <p-step-panels>
      <p-step-panel [value]="1">
        <ng-template #content let-activateCallback="activateCallback">
          <div
            class="mx-auto flex flex-col gap-2"
            style="min-height: 16rem; max-width: 20rem">
            <h3 class="mb-4 mt-4 text-center font-semibold">
              Create your account
            </h3>
            <div class="field"></div>
            <div class="field"></div>
            <div class="field"></div>
          </div>
          <div class="flex justify-end pt-6">
            <p-button
              (onClick)="activateCallback(2)"
              label="Next"
              icon="pi pi-arrow-right"
              iconPos="right" />
          </div>
        </ng-template>
      </p-step-panel>

      <p-step-panel [value]="2">
        <ng-template #content let-activateCallback="activateCallback">
          <div
            class="mx-auto flex flex-col gap-2"
            style="min-height: 16rem; max-width: 24rem">
            <h3 class="mb-4 mt-4 text-center font-semibold">
              Choose your interests
            </h3>
            <div class="flex flex-wrap justify-center gap-4"></div>
          </div>
          <div class="flex justify-between pt-6">
            <p-button
              (onClick)="activateCallback(1)"
              label="Back"
              severity="secondary"
              icon="pi pi-arrow-left" />
            <p-button
              (onClick)="activateCallback(3)"
              label="Next"
              icon="pi pi-arrow-right"
              iconPos="right" />
          </div>
        </ng-template>
      </p-step-panel>

      <p-step-panel [value]="3">
        <ng-template #content let-activateCallback="activateCallback">
          <div
            class="mx-auto flex flex-col gap-2"
            style="min-height: 16rem; max-width: 24rem">
            <h3 class="mb-4 mt-4 text-center font-semibold">
              Account created successfully
            </h3>
            <div class="text-center">
              <img
                alt="logo"
                src="https://primefaces.org/cdn/primeng/images/stepper/content.svg" />
            </div>
          </div>
          <div class="flex justify-start pt-6">
            <p-button
              (onClick)="activateCallback(2)"
              label="Back"
              severity="secondary"
              icon="pi pi-arrow-left" />
          </div>
        </ng-template>
      </p-step-panel>
    </p-step-panels>
  </p-stepper>
  <p-accordion value="0">
    <p-accordion-panel value="0">
      <p-accordion-header>Header I</p-accordion-header>
      <p-accordion-content> </p-accordion-content>
    </p-accordion-panel>

    <p-accordion-panel value="1">
      <p-accordion-header>Header II</p-accordion-header>
      <p-accordion-content> </p-accordion-content>
    </p-accordion-panel>

    <p-accordion-panel value="2">
      <p-accordion-header>Header III</p-accordion-header>
      <p-accordion-content> </p-accordion-content>
    </p-accordion-panel>
  </p-accordion>
</div>
